import * as React from "react";
const SvgFiRrW = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-w_svg__a)">
      <path
        fill="#062147"
        d="M6.843 24.013A4 4 0 0 1 6.549 24a3.495 3.495 0 0 1-3.221-2.953L.014 1.164a1 1 0 0 1 .82-1.15.99.99 0 0 1 1.152.822L5.3 20.72c.146.88.822 1.242 1.405 1.288.578.038 1.307-.207 1.589-1.054l2.757-8.271c.266-.895 1.632-.895 1.897 0l2.756 8.27c.282.847.997 1.094 1.589 1.055.583-.046 1.259-.408 1.405-1.288L22.014.836a1 1 0 1 1 1.972.328l-3.314 19.884A3.495 3.495 0 0 1 17.45 24a3.51 3.51 0 0 1-3.643-2.414l-1.81-5.425-1.807 5.425c-.493 1.479-1.816 2.426-3.348 2.426"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-w_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrW;
